// extracted by mini-css-extract-plugin
module.exports = {"richText":"myRichText_richText__n1pf9","darkRichText":"myRichText_darkRichText__SNfgJ"};